export default __webpack_public_path__ + "static/media/Parent_Parties_Login.ad5ae0e9.png";